import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { AccountTabsBuilderState, Tab } from 'src/domains/players/webview/components/Account';
import { useCommon } from 'src/domains/common/Common';

interface RhsTabsPropsType {
    tab: RightHandSideViewType | null;
}

export const RhsTabs = observer('RenderTab', (props: RhsTabsPropsType) => {
    const common = useCommon();
    const accountTabsBuilderState = AccountTabsBuilderState.get(common);

    const { tab } = props;
    const data = accountTabsBuilderState.getTabData(tab);

    if (data === null) {
        return null;
    }

    return (
        <Tab
            tabName={tab}
            showHeader={true}
            tabData={data}
            tabDataForHeader={data}
        />
    );
});
